(function($) {  

  $(document).ready(function() {
      initWishlist();
      initProductWishlist();
      initRemoveWishlist();
  }); 

  function initWishlist() {
    $(document).on('click', '.engoj_add_to_wishlist', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var form = $btn.closest('form');

      $.ajax({
        type: 'POST',
        url: '/contact',
        data: form.serialize(),
        beforeSend: function() {
          $btn.prop('disabled', true);
        },
        success: function(data) {
          $btn.toggleClass('added wish');
          var wasAdded = $btn.hasClass('added');
          $btn.attr('data-original-title', wasAdded
            ? "Bereits in der Wunschliste"
            : "Zur Wunschliste hinzufügen");
          var $input = form.find('input[name="contact[tags]"]');
          var val = $input.val();
          var rawTag = val.indexOf('x') === 0 ? val.substring(1) : val;
          $input.val(val.indexOf('x') === 0 ? val.substring(1) : 'x' + val);
          $btn.prop('disabled', false);
          try {
            var wlCache = JSON.parse(localStorage.getItem('wl_cache') || '{}');
            if (wasAdded) {
              wlCache[rawTag] = {
                vid: rawTag.split('_')[2],
                handle: $btn.data('product-handle'),
                title: $btn.data('product-title'),
                vtitle: $btn.data('variant-title'),
                url: $btn.data('product-url'),
                img: $btn.data('product-img'),
                price: parseInt($btn.data('price'), 10) || 0,
                cprice: parseInt($btn.data('compare-price'), 10) || 0,
                ts: Date.now()
              };
            } else {
              delete wlCache[rawTag];
            }
            localStorage.setItem('wl_cache', JSON.stringify(wlCache));
          } catch(e) {}
        },
        error: function(xhr, text) {
          $btn.prop('disabled', false);
          console.error('Wishlist error:', xhr.responseText);
        }
      });
    });

  }window.initWishlist=initWishlist;


  // Variants the customer picked via the multi-colour swatch quantity fields
  // (.swatch_neues_fenster), with their quantities. Mirrors warenkorb_hinzu().
  function getMultiSelected() {
    var out = [];
    document.querySelectorAll('.swatch_neues_fenster').forEach(function(input) {
      var qty = parseInt(input.value, 10);
      if (qty && qty > 0 && input.dataset.switchneu) {
        out.push({ vid: String(input.dataset.switchneu), qty: qty });
      }
    });
    return out;
  }

  // Wishlist customer tags can't carry a quantity, so persist the chosen qty
  // per variant in localStorage and re-apply it on the wishlist page.
  function cacheWishlistVariant(tag, qty) {
    try {
      var vid = tag.split('_')[2];
      var info = wlVariantInfo(vid);
      var wlCache = JSON.parse(localStorage.getItem('wl_cache') || '{}');
      wlCache[tag] = {
        vid: vid,
        handle: info.handle,
        title: info.title,
        vtitle: info.vtitle,
        url: info.url,
        img: info.img,
        price: info.price != null ? info.price : 0,
        cprice: info.cprice != null ? info.cprice : 0,
        qty: (qty && qty > 0) ? qty : 1,
        ts: Date.now()
      };
      localStorage.setItem('wl_cache', JSON.stringify(wlCache));
    } catch(e) {}
  }

  function initProductWishlist() {
    $('.engoj_add_to_wishlist_pd').click(function(e) {
      e.preventDefault();

      var $btn = $(this);
      var form = $btn.closest('form');
      var $input = form.find('input[name="contact[tags]"]');
      var prefix = $input.data('wl-prefix');

      // If the customer entered quantities for one or more colours via the
      // multi-select swatch, add ALL of those variants to the wishlist.
      var multiSel = getMultiSelected();

      if (multiSel.length && prefix) {
        // Submit ALL picked variants (idempotent — Shopify de-dupes tags), so the
        // action always succeeds even if some were already on the wishlist.
        var allTags = [];
        var qtyByTag = {};
        multiSel.forEach(function(it) {
          var t = prefix + it.vid;
          if (allTags.indexOf(t) === -1) { allTags.push(t); qtyByTag[t] = it.qty; }
        });

        $input.val(allTags.join(','));
        $.ajax({
          type: 'POST',
          url: '/contact',
          data: form.serialize(),
          beforeSend: function() { $btn.prop('disabled', true); },
          success: function(data) {
            $btn.toggleClass('added', true).toggleClass('wish', false);
            allTags.forEach(function(t) {
              if (window.__wishlistTags && window.__wishlistTags.indexOf(t) === -1) {
                window.__wishlistTags.push(t);
              }
              cacheWishlistVariant(t, qtyByTag[t]);
            });
            $btn.prop('disabled', false);
            // Clear, transient confirmation of how many variants were saved.
            var $span = $btn.find('span');
            if ($span.length) {
              var added = allTags.length;
              $span.text(added + (added === 1 ? ' Variante' : ' Varianten') + ' zur Wunschliste hinzugefügt');
              setTimeout(function() { $span.text("Bereits in der Wunschliste"); }, 2500);
            }
          },
          error: function(xhr) {
            $btn.prop('disabled', false);
            console.error('Wishlist error:', xhr.responseText);
          }
        });
        return;
      }

      // Single-variant mode: use the variant currently selected in #productSelect
      // (kept in sync by the swatch UI), toggling add/remove.
      var selVariant = $('#productSelect').length ? String($('#productSelect').val() || '') : '';
      var curTag = (prefix && selVariant) ? (prefix + selVariant) : null;
      var willBeAdded = null;
      if (curTag) {
        var alreadyIn = window.__wishlistTags && window.__wishlistTags.indexOf(curTag) !== -1;
        $input.val(alreadyIn ? 'x' + curTag : curTag);
        willBeAdded = !alreadyIn;
      }

      $.ajax({
        type: 'POST',
        url: '/contact',
        data: form.serialize(),
        beforeSend: function() {
          $btn.prop('disabled', true);
        },
        success: function(data) {
          var wasAdded;
          if (willBeAdded === null) {
            // No variant context (fallback): just flip the visual state.
            $btn.toggleClass('added wish');
            wasAdded = $btn.hasClass('added');
          } else {
            // Deterministic state for the selected variant.
            wasAdded = willBeAdded;
            $btn.toggleClass('added', wasAdded).toggleClass('wish', !wasAdded);
          }
          var $span = $btn.find('span');
          if ($span.length) {
            $span.text(wasAdded ? "Bereits in der Wunschliste" : "Zur Wunschliste hinzufügen");
          }
          var val = $input.val();
          var rawTag = val.indexOf('x') === 0 ? val.substring(1) : val;
          $input.val(val.indexOf('x') === 0 ? val.substring(1) : 'x' + val);
          // Keep the in-memory tag list in sync for repeat toggles / variant switches.
          if (window.__wishlistTags) {
            var idx = window.__wishlistTags.indexOf(rawTag);
            if (wasAdded && idx === -1) window.__wishlistTags.push(rawTag);
            if (!wasAdded && idx !== -1) window.__wishlistTags.splice(idx, 1);
          }
          $btn.prop('disabled', false);
          try {
            var wlCache = JSON.parse(localStorage.getItem('wl_cache') || '{}');
            if (wasAdded) {
              var vid = rawTag.split('_')[2];
              // Prefer live variant data from the product JSON so the optimistic
              // row matches the selected variant (image/price/title), not the default.
              var info = wlVariantInfo(vid);
              wlCache[rawTag] = {
                vid: vid,
                handle: info.handle || $btn.data('product-handle'),
                title: info.title || $btn.data('product-title'),
                vtitle: info.vtitle || $btn.data('variant-title'),
                url: info.url || $btn.data('product-url'),
                img: info.img || $btn.data('product-img'),
                price: info.price != null ? info.price : (parseInt($btn.data('price'), 10) || 0),
                cprice: info.cprice != null ? info.cprice : (parseInt($btn.data('compare-price'), 10) || 0),
                ts: Date.now()
              };
            } else {
              delete wlCache[rawTag];
            }
            localStorage.setItem('wl_cache', JSON.stringify(wlCache));
          } catch(e) {}
        },
        error: function(xhr, text) {
          $btn.prop('disabled', false);
          console.error('Wishlist error:', xhr.responseText);
        }
      });
    });
  };

  // Look up selected-variant details from the product JSON exposed on the PDP.
  function wlVariantInfo(vid) {
    var out = {};
    var p = window.__wlProduct;
    if (!p || !vid) return out;
    var v = (p.variants || []).filter(function(x) { return String(x.id) === String(vid); })[0];
    if (!v) return out;
    out.handle = p.handle;
    out.title = p.title;
    out.vtitle = v.title;
    out.url = '/products/' + p.handle + '?variant=' + vid;
    out.img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : p.featured_image;
    out.price = v.price;
    out.cprice = v.compare_at_price || 0;
    return out;
  }

  /* Remove Wishlist */
  function initRemoveWishlist() {
    $('.btn-remove-wishlist').click(function(e) {
      e.preventDefault();
      var row = $(this).parents('tr');
      var tagID = row.find('.tag-id').val();
      var form = jQuery('#remove-wishlist-form');
      form.find("input[name='contact[tags]']").val('x' + tagID);
      $.ajax({
        type: 'POST',
        url: '/contact',
        data: form.serialize(),
        beforeSend: function() {
          showPopup('.loading'); 

        },
        success: function(data) {
          row.fadeOut(1000);
          hidePopup('.loading');  
        },
        error: function(xhr, text) {
          $('.error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.error-popup');
        }
      });
    });
  };


})(jQuery);